import {Component, OnInit, ViewChild} from '@angular/core';
import {Evaluation, DamageDetails, SmartLabelsChartData, Employee, CarBrand, Receiver} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {MatLegacyOption as MatOption} from '@angular/material/legacy-core';
import {MatLegacySelect as MatSelect} from '@angular/material/legacy-select';
import {UntypedFormControl} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ColumnModel, EditSettingsModel, ToolbarItems, DetailRowService, GridModel, GridComponent} from '@syncfusion/ej2-angular-grids';
import {AccumulationAnnotationService, AccumulationDataLabelService, AccumulationLegendService, AccumulationTooltipService, PieSeriesService, IPointEventArgs} from '@syncfusion/ej2-angular-charts';
import {ClickEventArgs} from '@syncfusion/ej2-angular-navigations';
import {forkJoin} from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-damage-administration-evaluation',
  templateUrl: './damage-administration-evaluation.component.html',
  styleUrls: ['./damage-administration-evaluation.component.css'],
  providers: [DetailRowService, DatePipe, PieSeriesService, PieSeriesService, AccumulationLegendService, AccumulationTooltipService, AccumulationDataLabelService, AccumulationAnnotationService]
})
export class DamageAdministrationEvaluationComponent implements OnInit {
  @ViewChild('employeeGrid', {static: true}) private employeeGrid: GridComponent;
  @ViewChild('receiverGrid', {static: true}) private receiverGrid: GridComponent;
  @ViewChild('importerGrid', {static: true}) private importerGrid: GridComponent;
  @ViewChild('jobTypeGrid', {static: true}) private jobTypeGrid: GridComponent;
  @ViewChild('employeeSelect', {static: true}) private employeeSelect: MatSelect;
  @ViewChild('receiverSelect', {static: true}) private receiverSelect: MatSelect;
  @ViewChild('brandSelect', {static: true}) private brandSelect: MatSelect;

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
  ) { }

  /* DatePicker */
  public startDate: Date;
  public endDate: Date;
  public startDateString = '';
  public endDateString = '';
  /* Grids */
  public employeeDataSource: Evaluation[] = [];
  public receiverDataSource: Evaluation[] = [];
  public importerDataSource: Evaluation[] = [];
  public jobTypeDataSource: Evaluation[] = [];
  public employeeChildDataSource: DamageDetails[] = [];
  public receiverChildDataSource: DamageDetails[] = [];
  public importerChildDataSource: DamageDetails[] = [];
  public jobTypeChildDataSource: DamageDetails[] = [];
  public employeeColumns: ColumnModel[] = [];
  public receiverColumns: ColumnModel[] = [];
  public importerColumns: ColumnModel[] = [];
  public jobTypeColumns: ColumnModel[] = [];
  public employeeChildGrid: GridModel;
  public receiverChildGrid: GridModel;
  public importerChildGrid: GridModel;
  public jobTypeChildGrid: GridModel;
  public editSettings: EditSettingsModel;
  public toolbar: ToolbarItems[];
  public allowances = true;
  // public pageSettings: true;
  /* MultiSelects */
  public employeeFormControl = new UntypedFormControl();
  public receiverFormControl = new UntypedFormControl();
  public brandFormControl = new UntypedFormControl();
  public employeeList: Employee[] = [];
  public receiverList: Receiver[] = [];
  public brandList: CarBrand[] = [];
  public allEmployeesSelected = false;
  public allReceiversSelected = false;
  public allBrandsSelected = false;
  public disabledMultiSelects = true;
  /* Charts */
  public legendSettings = { visible: false };
  public map = 'fill';
  public dataLabel = { visible: true, position: 'Outside', name: 'text' };
  public enableSmartLabels = true;
  public tooltip = {
    enable: true,
    textStyle: {
      size: '18px',
      textAlignment: 'center',
      fontWeight: 'lighter',
      fontFamily: 'Arial, Helvetica, sans-serif;',
      textOverflow: 'trim'
    },
    format: '${point.y}'
  };
  public causedByChartDataSource: SmartLabelsChartData[] = [];
  public receiverChartDataSource: SmartLabelsChartData[] = [];
  public brandChartDataSource: SmartLabelsChartData[] = [];
  public employeeUniqueIds: string;
  public receiverUniqueIds: string;
  public brandUniqueIds: string;

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(13);
    this.initGrids();
  }

  loadData() {
    console.log('start');
    if (this.startDate == null || this.endDate == null) { return; }
    this.startDateString = this.startDate.toLocaleDateString('de-DE');
    this.endDateString = this.endDate.toLocaleDateString('de-DE');
    console.log(this.startDateString + ' + ' + this.endDateString);
    const damageStatisticsByEmpList = this.damageAdministrationService.getDamageStatisticsByEmp(this.startDateString, this.endDateString);
    const damageStatisticsByRecList = this.damageAdministrationService.getDamageStatisticsByRec(this.startDateString, this.endDateString);
    const damageStatisticsByImpList = this.damageAdministrationService.getDamageStatisticsByImp(this.startDateString, this.endDateString);
    const jobTypeStatisticsByJobTypeList = this.damageAdministrationService.getDamageStatisticsByJobType(this.startDateString, this.endDateString);
    const employeeList = this.damageAdministrationService.getEmployees();
    const receiverList = this.damageAdministrationService.getReceivers();
    const carBrandList = this.damageAdministrationService.getCarBrands();
    forkJoin([damageStatisticsByEmpList, damageStatisticsByRecList, damageStatisticsByImpList, employeeList, receiverList, carBrandList, jobTypeStatisticsByJobTypeList]).subscribe((result: any) => {
      this.employeeDataSource = result[0];
      this.receiverDataSource = result[1];
      this.importerDataSource = result[2];
      this.jobTypeDataSource = result[6];
      this.employeeList = result[3].Obj.filter(o => o.IsAdministrator !== true).sort((a, b) => a.LastName < b.LastName ? 1 : -1);
      this.receiverList = result[4].Obj;
      this.brandList = result[5].Obj;
      this.employeeDataSource.forEach(parent => {
        parent.DamageDetails.forEach(child => {
          child.UniqueId = parent.UniqueId;
          this.employeeChildDataSource.push(child);
        });
      });
      this.receiverDataSource.forEach(parent => {
        parent.DamageDetails.forEach(child => {
          child.UniqueId = parent.UniqueId;
          this.receiverChildDataSource.push(child);
        });
      });
      this.importerDataSource.forEach(parent => {
        parent.DamageDetails.forEach(child => {
          child.UniqueId = parent.UniqueId;
          this.importerChildDataSource.push(child);
        });
      });
      this.jobTypeDataSource.forEach(parent => {
        parent.DamageDetails.forEach(child => {
          child.UniqueId = parent.UniqueId;
          this.jobTypeChildDataSource.push(child);
        });
      });
      this.employeeChildGrid = {
        queryString: 'UniqueId',
        dataSource: this.employeeChildDataSource,
        columns: [
          { field: 'DocNum', headerText: 'Dokumenten Nr.', textAlign: 'Left'},
          { field: 'DamageDate', headerText: 'Schadensdatum', textAlign: 'Left', type: 'Date', format: 'dd.MM.yyyy'},
          { field: 'ChassisNo', headerText: 'Chassis-Nr.', textAlign: 'Left'},
          { field: 'Identification', headerText: 'Identifikation.', textAlign: 'Left'},
          { field: 'CarBrandName', headerText: 'Marke', textAlign: 'Left'},
          { field: 'ReceiverName', headerText: 'Empfänger', textAlign: 'Left'},
          { field: 'DamageAmount', headerText: 'Schadensbetrag', textAlign: 'Right', format: 'N2'},
        ],
      };
      this.receiverChildGrid = {
        queryString: 'UniqueId',
        dataSource: this.receiverChildDataSource,
        columns: [
          { field: 'DocNum', headerText: 'Dokumenten Nr.', textAlign: 'Left'},
          { field: 'DamageDate', headerText: 'Schadensdatum', textAlign: 'Left', type: 'Date', format: 'dd.MM.yyyy' },
          { field: 'ChassisNo', headerText: 'Chassis-Nr.', textAlign: 'Left'},
          { field: 'Identification', headerText: 'Identifikation.', textAlign: 'Left'},
          { field: 'CarBrandName', headerText: 'Marke', textAlign: 'Left'},
          { field: 'ReceiverName', headerText: 'Empfänger', textAlign: 'Left'},
          { field: 'DamageAmount', headerText: 'Schadensbetrag', textAlign: 'Right', format: 'N2'},
        ],
      };
      this.importerChildGrid = {
        queryString: 'UniqueId',
        dataSource: this.importerChildDataSource,
        columns: [
          { field: 'DocNum', headerText: 'Dokumenten Nr.', textAlign: 'Left'},
          { field: 'DamageDate', headerText: 'Schadensdatum', textAlign: 'Left', type: 'Date', format: 'dd.MM.yyyy' },
          { field: 'ChassisNo', headerText: 'Chassis-Nr.', textAlign: 'Left'},
          { field: 'Identification', headerText: 'Identifikation.', textAlign: 'Left'},
          { field: 'CarBrandName', headerText: 'Marke', textAlign: 'Left'},
          { field: 'ReceiverName', headerText: 'Empfänger', textAlign: 'Left'},
          { field: 'DamageAmount', headerText: 'Schadensbetrag', textAlign: 'Right', format: 'N2'},
        ],
      };
      this.jobTypeChildGrid = {
        queryString: 'UniqueId',
        dataSource: this.jobTypeChildDataSource,
        columns: [
          { field: 'DocNum', headerText: 'Dokumenten Nr.', textAlign: 'Left'},
          { field: 'DamageDate', headerText: 'Schadensdatum', textAlign: 'Left', type: 'Date', format: 'dd.MM.yyyy' },
          { field: 'ChassisNo', headerText: 'Chassis-Nr.', textAlign: 'Left'},
          { field: 'Identification', headerText: 'Identifikation.', textAlign: 'Left'},
          { field: 'CarBrandName', headerText: 'Marke', textAlign: 'Left'},
          { field: 'ReceiverName', headerText: 'Empfänger', textAlign: 'Left'},
          { field: 'DamageAmount', headerText: 'Schadensbetrag', textAlign: 'Right', format: 'N2'},
        ],
      };
      this.disabledMultiSelects = false;
    });
  }

  initGrids() {
    this.toolbar = ['ExcelExport', 'PdfExport', 'Print', 'Search'];
    this.editSettings =  { allowAdding: false, allowEditing: false, allowDeleting: false, mode: 'Normal' };
    this.employeeColumns = [
      {
        field: 'UniqueId',
        headerText: 'UniqueId',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
      },
      {
        field: 'CausedBy',
        headerText: 'Verursacher',
        textAlign: 'Left'
      },
      {
        field: 'CountOfDamages',
        headerText: 'Anzahl verursachter Schäden',
        textAlign: 'Right'
      },
      {
        field: 'DamageAmountSum',
        headerText: 'Schadenssumme',
        textAlign: 'Right',
        format: 'N2'
      },
      {
        field: 'QuantityCarTransport',
        headerText: 'Anzahl transportierter Fahrzeuge',
        textAlign: 'Right'
      },
      {
        field: 'Quote',
        headerText: 'Quote',
        textAlign: 'Right',
        format: 'N2'
      },
    ];
    this.receiverColumns = [
      {
        field: 'UniqueId',
        headerText: 'UniqueId',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
      },
      {
        field: 'CustomerType',
        headerText: 'Empfänger',
        textAlign: 'Left'
      },
      {
        field: 'CountOfDamages',
        headerText: 'Anzahl gemeldeter Schäden',
        textAlign: 'Right'
      },
      {
        field: 'DamageAmountSum',
        headerText: 'Schadenssumme',
        textAlign: 'Right',
        format: 'N2'
      },
      {
        field: 'QuantityCarTransport',
        headerText: 'Anzahl gelieferter Fahrzeuge',
        textAlign: 'Right'
      },
      {
        field: 'Quote',
        headerText: 'Quote',
        textAlign: 'Right',
        format: 'N2'
      },
    ];
    this.importerColumns = [
      {
        field: 'UniqueId',
        headerText: 'UniqueId',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
      },
      {
        field: 'CustomerType',
        headerText: 'Importeur',
        textAlign: 'Left'
      },
      {
        field: 'CountOfDamages',
        headerText: 'Anzahl gemeldeter Schäden',
        textAlign: 'Right'
      },
      {
        field: 'DamageAmountSum',
        headerText: 'Schadenssumme',
        textAlign: 'Right',
        format: 'N2'
      },
      {
        field: 'QuantityCarTransport',
        headerText: 'Anzahl importierter Fahrzeuge',
        textAlign: 'Right'
      },
      {
        field: 'Quote',
        headerText: 'Quote',
        textAlign: 'Right',
        format: 'N2'
      },
    ];
    this.jobTypeColumns = [
      {
        field: 'UniqueId',
        headerText: 'UniqueId',
        textAlign: 'Left',
        isPrimaryKey: true,
        visible: false,
      },
      {
        field: 'CustomerType',
        headerText: 'Auftragstyp',
        textAlign: 'Left'
      },
      {
        field: 'CountOfDamages',
        headerText: 'Anzahl gemeldeter Schäden',
        textAlign: 'Right'
      },
      {
        field: 'DamageAmountSum',
        headerText: 'Schadenssumme',
        textAlign: 'Right',
        format: 'N2'
      },
      {
        field: 'QuantityCarTransport',
        headerText: 'Anzahl importierter Fahrzeuge',
        textAlign: 'Right'
      },
      {
        field: 'Quote',
        headerText: 'Quote',
        textAlign: 'Right',
        format: 'N2'
      }
    ];
  }

  toggleAllEmployeesSelection() {
    this.allEmployeesSelected = !this.allEmployeesSelected;
    if (this.allEmployeesSelected) {
      this.employeeSelect.options.forEach((item: MatOption) => item.select());
    } else {
      this.employeeSelect.options.forEach((item: MatOption) => item.deselect());
    }
  }
  toggleAllReceiversSelection() {
    this.allReceiversSelected = !this.allReceiversSelected;
    if (this.allReceiversSelected) {
      this.receiverSelect.options.forEach((item: MatOption) => item.select());
    } else {
      this.receiverSelect.options.forEach((item: MatOption) => item.deselect());
    }
  }
  toggleAllBrandsSelection() {
    this.allBrandsSelected = !this.allBrandsSelected;
    if (this.allBrandsSelected) {
      this.brandSelect.options.forEach((item: MatOption) => item.select());
    } else {
      this.brandSelect.options.forEach((item: MatOption) => item.deselect());
    }
  }

  getCausedByChart() {
    this.employeeUniqueIds = '';
    this.employeeSelect.options.forEach(o => o.selected ? this.employeeUniqueIds += o.value + ',' : this.employeeUniqueIds += '');
    if (this.employeeUniqueIds !== '') { this.employeeUniqueIds = this.employeeUniqueIds.substring(0, this.employeeUniqueIds.length - 1); }
    if (this.employeeUniqueIds.startsWith('0,')) { this.employeeUniqueIds = this.employeeUniqueIds.substring(2, this.employeeUniqueIds.length - 2); }
    this.damageAdministrationService.getPieChartData(this.startDateString, this.endDateString, this.employeeUniqueIds, 'ResourceDDL').subscribe((smartLabelsChartDataList: SmartLabelsChartData[]) => {
      this.causedByChartDataSource = smartLabelsChartDataList !== null ? smartLabelsChartDataList : [];
    });
  }
  getReceiverChart() {
    this.receiverUniqueIds = '';
    this.receiverSelect.options.forEach(o => o.selected ? this.receiverUniqueIds += o.value + ',' : this.receiverUniqueIds += '');
    if (this.receiverUniqueIds !== '') { this.receiverUniqueIds = this.receiverUniqueIds.substring(0, this.receiverUniqueIds.length - 1); }
    if (this.receiverUniqueIds.startsWith('0,')) { this.receiverUniqueIds = this.receiverUniqueIds.substring(2, this.receiverUniqueIds.length - 2); }
    this.damageAdministrationService.getPieChartData(this.startDateString, this.endDateString, this.receiverUniqueIds, 'ReceiverDDL').subscribe((smartLabelsChartDataList: SmartLabelsChartData[]) => {
      this.receiverChartDataSource = smartLabelsChartDataList !== null ? smartLabelsChartDataList : [];
    });
  }
  getBrandChart() {
    this.brandUniqueIds = '';
    this.brandSelect.options.forEach(o => o.selected ? this.brandUniqueIds += o.value + ',' : this.brandUniqueIds += '');
    if (this.brandUniqueIds !== '') { this.brandUniqueIds = this.brandUniqueIds.substring(0, this.brandUniqueIds.length - 1); }
    if (this.brandUniqueIds.startsWith('0,')) { this.brandUniqueIds = this.brandUniqueIds.substring(2, this.brandUniqueIds.length - 2); }
    this.damageAdministrationService.getPieChartData(this.startDateString, this.endDateString, this.brandUniqueIds, 'BrandDDL').subscribe((smartLabelsChartDataList: SmartLabelsChartData[]) => {
      this.brandChartDataSource = smartLabelsChartDataList !== null ? smartLabelsChartDataList : [];
    });
  }

  findArray(arr, searchPattern) {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].xValue === searchPattern) {
        return arr[i];
      }
    }
  }
  onPointClick(e: IPointEventArgs) {
    // @ts-ignore
    const found = this.findArray(e.series.resultData, e.point.x);

    let id;
    let mode;
    // @ts-ignore
    switch (e.series.parentObj.element.id) {
      case 'causedByChartContainer': mode = 'EMP'; id = this.employeeUniqueIds; break;
      case 'receiverChartContainer': mode = 'REC'; id = this.receiverUniqueIds; break;
      case 'brandChartContainer': mode = 'TYP'; id = this.brandUniqueIds; break;
      default: return;
    }

    let diagText = '<table class="greyGridTable"><thead><tr><th>Doc Nr.</th><th>Empfänger</th><th>Verursacher</th><th>Schadenbetrag</th><th>Model</th></tr></thead>';
    this.damageAdministrationService.getAdditionalDataFromDamage(this.startDateString, this.endDateString, id, found.xValue, mode).subscribe((result: any) => {
      if (result !== null) {
        result.forEach(r => {
          diagText += '<tbody><tr><td><a target="_blank" rel="noopener noreferrer" href="/#/damageAdministrationRecord/' + r.DocNum + '"</a>' + r.DocNum + '</td>';
          diagText += '<td>' + r.ReceiverName + '</td><td>' + r.LastName + '</td><td>' + r.DamageAmount.toFixed(2) + '</td><td>' + r.CarTypeName + '</td></tr></tbody>';
        });
      }
      diagText += '</table><hr><p>Schadenssumme Total: ' + found.sumOfDamageAmount + ' CHF</p><hr>';

      Swal.fire({
        title: e.point.text,
        html: diagText,
        confirmButtonColor: '#d33',
        icon: 'info',
        confirmButtonText: 'OK',
        width: '800px',
        customClass: { content: 'greyGridTable' }
      });
    });
  }

  onToolbarClick($event: ClickEventArgs) {
    if ($event.item.id === 'employeeGrid_excelexport') { this.employeeGrid.excelExport(); }
    if ($event.item.id === 'employeeGrid_pdfexport') { this.employeeGrid.pdfExport(); }
    if ($event.item.id === 'receiverGrid_excelexport') { this.receiverGrid.excelExport(); }
    if ($event.item.id === 'receiverGrid_pdfexport') { this.receiverGrid.pdfExport(); }
    if ($event.item.id === 'importerGrid_excelexport') { this.importerGrid.excelExport(); }
    if ($event.item.id === 'importerGrid_pdfexport') { this.importerGrid.pdfExport(); }
    if ($event.item.id === 'jobTypeGrid_excelexport') { this.jobTypeGrid.excelExport(); }
    if ($event.item.id === 'jobTypeGrid_pdfexport') { this.jobTypeGrid.pdfExport(); }
  }
}
